import { FC, SVGProps } from 'react';

export const DEFAULT_PAGE_SIZE = 8;

export type StaticImageData = {
  src: string;
  height: number;
  width: number;
  blurDataURL?: string;
};

export interface IFile {
  id: number;
  name: string;
  url: string;
  size: number;
  mime: string;
}

export interface FormSubscribeRequest {
  phoneNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  comment: string;
  subscription?: string;
}

export interface FormQuestionnaireRequest {
  phoneNumber: string;
  email: string;
  niche: string;
  fullName: string;
  telegramNickname: string;
  partnerOrSpeaker: string;
}

export interface ApiResponse {
  success: boolean;
}

export interface SuccessApiResponse<Data> extends ApiResponse {
  data: Data;
  message?: string;
}

export interface ApiErrorDetails {
  /** Прикладная причина отказа, например `course_debt`. */
  reason?: string;
  courseId?: number;
  [key: string]: unknown;
}

export interface RejectApiResponse extends ApiResponse {
  message: string;
  /** HTTP-статус ответа, если он был. */
  status?: number;
  /** Машинный тип ошибки: `error.type` у нашего API, `error.name` у Strapi. */
  type?: string;
  /** `error.details` — по нему различаются прикладные отказы. */
  details?: ApiErrorDetails;
}

export interface ErrorApiResponse<
  Error extends object | undefined = undefined,
> extends ApiResponse {
  message: string;
  errors?: Error;
}

export type TablePaginationType = {
  page: number;
  pageSize: number;
  total: number;
  pageCount: number;
};

export type SvgType = FC<SVGProps<SVGSVGElement>> | string;

export type ImageType = string | StaticImageData | null;

export type AnyFunction = (...args: any[]) => any;

export type ObjectType = Record<string, any>;

export interface SeoData {
  [key: string]: ObjectType;
}

export type Primitive = string | number | boolean | null;

export type Unit = 'px' | '%' | 'rem' | 'em';

export type ResponsiveSize =
  | `${number}${Unit}`
  | number
  | {
      desktop: `${number}${Unit}` | number;
      mobile: `${number}${Unit}` | number;
    };

export type ResponsiveImage = {
  mobile?: ImageType;
  tablet?: ImageType;
  desktop: ImageType;
};

export type Social = {
  url: string;
  icon: SvgType;
};

export type Speaker = {
  id: number;
  name: string;
  description: string;
  image: StaticImageData;
  url: string;
};

export type PartnerItem = {
  id: number;
  icon: SvgType;
};

export type MenuItem = {
  id: number;
  label: string;
  href?: string;
  icon?: any;
  children?: MenuItem[];
};

export type SkillItemType = {
  id: number;
  title: string;
  description: string;
  tags: string[];
};

export type SortOptions = {
  id: string;
  title: string;
  options: {
    label: string;
    value: string;
  }[];
};

export type SocialType = {
  id: number;
  name: string;
  link: string;
  iconUrl?: string;
};

export interface UserShortInfo {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  avatar: string | null;
  email: string;
  blocked: boolean;
}

export enum AcademicRecordType {
  LeadTeacher = 'leadTeacher',
  ModuleTeacher = 'moduleTeacher',
  Lecturer = 'lecturer',
}

export const ACADEMIC_RECORD_TYPE_LABELS: Record<AcademicRecordType, string> = {
  [AcademicRecordType.LeadTeacher]: 'Lead teacher',
  [AcademicRecordType.ModuleTeacher]: 'Module teacher',
  [AcademicRecordType.Lecturer]: 'Lecturer',
};
